import * as actionTypes from '../actionTypes';

const modalVisibleState = {
  isCreatingEventModalVisible: false,
};

export default function modalVisibleReducer(state = modalVisibleState, action) {
  switch (action.type) {
    case actionTypes.SET_CREATING_EVENT_MODAL_VISIBLE:
      return {
        ...state,
        isCreatingEventModalVisible: action.visible,
      };
    default:
      return state;
  }
}
